module.exports = __webpack_public_path__ + "img/Stemness-MELA_SpatialResearch.dde4bb8c.png";